<template>
  <!-- <V4ResponsivePanel side="bottom"> -->
    <V4ResponsivePanel
  side="bottom"
  :model-value="modelValue"
  @update:model-value="handlePanelClose"
>

    <UCard :ui="ui">
      <template #header>
        <div class="inline-flex items-center justify-between w-full">
          <p class="text-md">Filters</p>
          <div class="flex justify-center" @click="handlePanelClose(false)">
            <UIcon name="i-heroicons-x-mark" class="h-5 w-5" />
          </div>
        </div>
      </template>

      <div class="flex flex-row h-96">
        <div class="basis-2/5 bg-gray-100 dark:bg-transparent overflow-x-hidden overflow-y-scroll">
          <div class="flex flex-col">
            <div class="p-4 text-sm border-b last:border-b-0 cursor-pointer"
              :class="item.value === selected.value ? 'bg-white dark:bg-gray-500/40' : ''"
              v-for="(item, index) in items" :key="index" @click="selected = item">
              <p>{{ item.label }}</p>
            </div>
          </div>
        </div>
        <div class="basis-3/5 p-5 overflow-x-hidden overflow-y-scroll">
          <div class="flex flex-col gap-10 py-10 w-full pr-4" v-if="selected.id === 'filter_price_range'">
            <MRange v-model="filters[selected.value]" :min="selected.options[0].min" :max="selected.options[0].max"
              :smooth="true" thumb-size="large" :renderTopOnActive="true" :range-highlight="true" class="w-full px-2"
              @update:modelValue="onFilterChange(filters[selected.value])">
              <template #top="{ data }">
                <span class="text-sm">&#8377;{{ data }}</span>
              </template>
            </MRange>
            <div class="">
              Price: &#8377;{{ filters[selected.value][0] }} - &#8377;{{ filters[selected.value][1] }}
            </div>
          </div>
          <div class="flex flex-col gap-4" v-else-if="selected.config.multiple">
            <template v-for="(item, index) in selected.options" :key="index">
              <UCheckbox 
                v-if="item.value" 
                :label="item.label" 
                :value="item.value" 
                v-model="filters[selected.value]" 
                @update:modelValue="onFilterChange(filters[selected.value])" 
              />
              <!-- Render empty space if item has no value -->
              <div v-else class="h-3"></div>
            </template>
          </div>
          <div class="flex flex-col gap-2" v-else>
            <URadioGroup :options="selected.options" :ui="{ fieldset: 'space-y-4' }" v-model="filters[selected.value]"
              @update:modelValue="onFilterChange" />
          </div>
        </div>
      </div>

      <template #footer>
        <div class="inline-flex items-center justify-between w-full">
          <UButton size="sm" variant="link" label="Reset" class="w-auto" :ui="{ base: 'normal-case' }" @click="reset" />
          <UButton size="sm" label="Apply" @click="apply" />
        </div>
      </template>
    </UCard>
  </V4ResponsivePanel>
</template>

<script setup>
// const props = defineProps(['items', 'preset']);
// const emit = defineEmits(['apply', 'close', 'labels-change']);

const props = defineProps(['items', 'preset', 'modelValue']);
const emit = defineEmits(['apply', 'close', 'labels-change', 'update:modelValue']);


const route = useRoute();

const isSearchV2 = computed(() => route.path.includes('search-v2'));
const { gtag } = useGtag();
const auth = useAuth();
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated ? {
  user_name: auth.user.first_name,
  user_phone: auth.user.phone,
  user_email: auth.user.email,
} : {
  user_name: null,
  user_phone: null,
  user_email: null
};

const computeFilterObject = () => Object.fromEntries(
  props.items.map(k => [
    k.value,
    props.preset[k.value] ||
    (k.id === 'filter_price_range'
      ? [k.options[0].min, k.options[0].max]
      : (k.config.multiple ? [] : null))
  ])
);
const filters = ref(computeFilterObject());
const selected = ref(props.items[0]);
const labelsState = reactive({});

const apply = () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'apply',
    [EventParameter.FILTER_DATA]: JSON.stringify(filters.value),
  });
  emit('apply', filters.value);
  if(isSearchV2) {
    emit('labels-change', { ...labelsState });
  }
};
const reset = () => {
  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: 'reset',
    [EventParameter.FILTER_DATA]: JSON.stringify(filters.value),
  });
  filters.value = Object.fromEntries(
    props.items.map(k => [
      k.value,
      (k.id === 'filter_price_range'
        ? [k.options[0].min, k.options[0].max]
        : (k.config.multiple ? [] : null))
    ])
  )

  if (isSearchV2) {
    Object.keys(labelsState).forEach(k => {
      labelsState[k] = [];
    });
    selected.value = props.items[0];

    // Emit updated labels state
    emit('labels-change', { ...labelsState });
  }
};

const ui = {
  header: { padding: 'px-4 py-3 sm:px-5' },
  body: { padding: 'px-0 py-0 sm:p-0' }
}

const onFilterChange = (val) => {
  if (isSearchV2) {
    const key = selected.value.value;
    const options = selected.value.options;


    let newLabels = [];

    if (selected.value.id === 'filter_price_range' && Array.isArray(val)) {
      const [min, max] = val;
      newLabels = [{ value: min, label: `₹${min} - ₹${max}` }];
    } else if (Array.isArray(val)) {
      newLabels = options
        .filter(o => val.includes(o.value))
        .map(o => ({ value: o.value, label: o.label }));
    } else {
      const o = options.find(o => o.value === val);
      if (o) newLabels = [{ value: o.value, label: o.label }];
    }
    labelsState[key] = newLabels;
  }

};

onMounted(() => {
  if (isSearchV2) {

    for (const [key, value] of Object.entries(props.preset)) {
      const item = props.items.find(i => i.value === key);

      if (!item || value == null) continue;

      let newLabels = [];

      if (item.id === 'filter_price_range' && Array.isArray(value)) {
        const [min, max] = value;
        // Skip if it matches the default full-range config
        const defaultPriceOption = item.options?.[0];
        if (defaultPriceOption && min === defaultPriceOption.min && max === defaultPriceOption.max) {
          continue;
        }
        newLabels = [{ label: `₹${min} - ₹${max}`, value: min, max }];
      } else if (item.config?.multiple && Array.isArray(value)) {
        newLabels = item.options
          .filter(o => value.includes(o.value))
          .map(o => ({ value: o.value, label: o.label }));
      } else {
        const o = item.options?.find(o => o.value === value);
        if (o) {
          newLabels = [{ value: o.value, label: o.label }];
        } else if (typeof value === 'string' || typeof value === 'number') {
          newLabels = item.options
            .filter(o => value.includes(o.value))
            .map(o => ({ value: o.value, label: o.label }));
        }
      }

      if (newLabels.length) {
        labelsState[key] = newLabels;
      }
    }
    emit('labels-change', { ...labelsState });
  }

});
import { popupBackHandler } from '@/composables/popupBackHandler'; // correct path as per your project
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';
const { closePopup } = popupBackHandler();

const handlePanelClose = (val) => {
  if (!val) {
    emit('update:modelValue', false); // this updates v-model in parent
    emit('close');          
    // closePopup();        // this triggers popupBackHandler
  }
};
</script>